<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="12"
      xl="12"
      v-for="(value, key) of data"
      :key="key"
      >
      <StreamfieldBlock v-for="(block, i) in value" :key="i" :block="block"/>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "OneColumnBlock",
  props: ["data"],
  beforeCreate: function () {
    //Prevents recustive importing...
    this.$options.components.StreamfieldBlock = require('../streamfieldBlock.vue').default
  }
};
</script>

<style scoped>
</style>